import { getApiUrl } from '../config';

export const getAvatarUrl = (user) => {
    if (!user) return '';
    const avatar = typeof user === 'string' ? user : user.avatar;
    if (!avatar) return '';
    if (/^https?:\/\//i.test(avatar) || avatar.startsWith('data:') || avatar.startsWith('blob:')) {
        return avatar;
    }
    const userId = typeof user === 'string' ? null : user._id;
    if (!userId) return '';
    return `${getApiUrl()}/user/${userId}/avatar`;
};
